import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
  ViewEncapsulation,
} from '@angular/core';
import { IComboBase } from '../../../interfaces/base/base.interface';
import { CompanyService } from '../../../services/company.service';
import { EmployeeService } from '../../../services/employee.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { ModalInfoComponent } from '../modal-info/modal-info.component';
import { VacationService } from '../../services/vacation.service';
import { TypeVacationService } from '../../../services/type-vacation.service';
import {
  numberToText,
  getMonthName,
  extractFileName,
  getDayLabel,
} from '../../../utils/helpers';

@Component({
  selector: 'app-vacation-register-modal',
  templateUrl: './vacation-register-modal.component.html',
  styleUrls: ['./vacation-register-modal.component.scss'],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None,
})
export class VacationRegisterModalComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() registerComplete = new EventEmitter<void>();
  userData: any = null;
  employeeData: any;
  getDayLabel = getDayLabel;

  constructor(
    private vacationService: VacationService,
    private typeVacationService: TypeVacationService,
    private companyService: CompanyService,
    private employeeService: EmployeeService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {}

  // Propiedades para los combos
  selectedEmpresa: IComboBase | null = null;
  selectedColaborador: IComboBase | null = null;

  startDate: Date | null = null;
  endDate: Date | null = null;
  minDate: Date | null = null;
  maxStartDate: Date | null = null;
  maxEndDate: Date | null = null;
  tooltipVisible: string | null = null;

  startDateEmployee: Date | null = null;

  vacationTypes: IComboBase[] = [];
  selectedOptionKey: string | null = null;

  accumulatedDays: number = 0;
  usedDaysLaw: number = 0;
  accumulatedBonusDays: number = 0;
  usedBonusDays: number = 0;
  selectedVacationType: IComboBase | null = null;
  filteredVacationTypes: IComboBase[] = [];
  totalDays: number = 0;
  currentFile: File | null = null;
  downloadUrl: string | null = null;
  documentGenerated: boolean = false;
  // transferableDays = Math.max(0, this.accumulatedDays - this.totalDays);

  selectedDates: Date[] = [];
  messageCollaborator = '';
  messageToCollaborator = '';

  filteredOptions: IComboBase[] = [];
  empresas: IComboBase[] = [];
  colaboradores: IComboBase[] = [];

  companyId: string | null = null;
  employeeId: number | null = null;

  @ViewChild('pdfUploader') pdfUploader: any;

  selectedFileName: string | null = null;

  isDisabled: boolean = true;

  statusSolicitude: IComboBase[] = [
    { key: '1', text: 'Recibida' },
    { key: '2', text: 'En evaluación' },
    { key: '3', text: 'Rechazado' },
    { key: '4', text: 'Aprobado' },
  ];
  selectedstatusSolicitude: any;

  hasInteracted: { [key: string]: boolean } = {
    empresa: false,
    colaborador: false,
    tipoVacacion: false,
    endDate: false,
    startDate: false,
  };

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }

    this.resetForm();
    this.calculateTotalDays();

    if (this.statusSolicitude.length > 0) {
      this.selectedstatusSolicitude = this.statusSolicitude[0];
    }

    this.companyService.comboCompany().subscribe({
      next: (data) => {
        this.empresas = data;
      },
      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
      },
    });

    this.typeVacationService.comboTypeVacation().subscribe({
      next: (data) => {
        this.vacationTypes = data;
        this.filterVacationTypesBasedOnSeniority();
      },

      error: (err) => {
        console.error('Error al obtener la lista de tipos de vacaciones:', err);
      },
    });
  }

  ngAfterViewInit(): void {
    this.employeeService.employeeData$.subscribe((data) => {
      if (data != null) {
        this.employeeData = data;
        // console.log('this.employeeData ', this.employeeData);

        if (this.employeeData && this.employeeData.startDate) {
          const [day, month, year] = this.employeeData.startDate.split('/');
          this.startDateEmployee = new Date(`${year}-${month}-${day}`);
          this.filterVacationTypesBasedOnSeniority();

          this.accumulatedDays = this.employeeData.accumulatedDays;
          this.accumulatedBonusDays = this.employeeData.accumulatedBonusDays;
          this.usedBonusDays = this.employeeData.usedBonusDays;
          this.usedDaysLaw = this.employeeData.usedDays;

          // console.log(
          //   'datos: ',
          //   this.accumulatedDays,
          //   this.accumulatedBonusDays,
          //   this.usedBonusDays,
          //   this.usedDaysLaw
          // );
        } else {
          console.error('employeeData o startDate es null o undefined');
        }
        this.cdr.detectChanges();
      }
    });
  }

  validateForm() {
    const isType4 = this.selectedVacationType?.key == '4';

    this.isDisabled = !(
      (
        this.selectedEmpresa &&
        this.selectedColaborador &&
        this.startDate &&
        this.endDate &&
        this.selectedVacationType &&
        (!isType4 || (isType4 && this.downloadUrl))
      ) // Si es tipo 4, debe tener archivo
    );
    // console.log('this.isDisabled:', this.isDisabled);
  }

  // Método para filtrar opciones
  filterOptions(event: any, type: string) {
    const query = event.query.toLowerCase();
    let options: IComboBase[] = [];
    switch (type) {
      case 'empresa':
        options = this.empresas;
        break;
      case 'colaborador':
        options = this.colaboradores;
        break;
      case 'status':
        options = this.statusSolicitude;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.filteredOptions = options.filter((option) =>
      option.text.toLowerCase().includes(query)
    );
  }

  // Manejar selección
  onSelect(event: any, type: string) {
    this.hasInteracted[type] = true;

    switch (type) {
      case 'empresa':
        this.selectedEmpresa = event.value ?? null;
        this.companyId = this.selectedEmpresa?.key!;
        this.selectedColaborador = null;
        this.resetDocumentState();

        if (this.companyId) {
          this.employeeService.comboEmployee(this.companyId).subscribe({
            next: (data) => {
              this.colaboradores = data;
            },
            error: (err) => {
              console.error('Error al obtener la lista de colaboradores:', err);
            },
          });
        }

        break;
      case 'colaborador':
        this.selectedColaborador = event.value ?? null;
        this.employeeId = Number(this.selectedColaborador?.key!);
        this.resetDocumentState();

        if (this.employeeId) {
          this.employeeService.getEmployeeById(this.employeeId).subscribe({
            next: (data) => {
              this.accumulatedDays = data.accumulatedDays;
              const [day, month, year] = data.startDate.split('/');
              this.startDateEmployee = new Date(`${year}-${month}-${day}`);
              this.filterVacationTypesBasedOnSeniority();
            },
            error: (err) => {
              console.error('Error al obtener la lista de colaboradores:', err);
            },
          });
        }

        break;
      case 'tipoVacacion':
        this.selectedVacationType = event.value ?? null;
        this.selectedOptionKey = this.selectedVacationType?.key || null;
        this.resetDocumentState();

        if (this.startDate) {
          if (this.selectedVacationType?.key != '4') {
            this.maxEndDate = new Date(this.startDate);
            this.maxEndDate.setDate(this.maxEndDate.getDate() + 14);
          } else {
            this.maxEndDate = null;
          }
        }

        if (this.selectedDates.length > 0) {
          this.selectedDates = [this.selectedDates[0]];
          this.endDate = null;
          this.onRangeSelect();
        }

        break;
      case 'status':
        this.selectedstatusSolicitude = event.value ?? null;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }

    this.validateForm();
  }

  filterVacationTypesBasedOnSeniority(): void {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    if (
      this.startDateEmployee &&
      this.startDateEmployee.getTime() <= oneYearAgo.getTime()
    ) {
      this.filteredVacationTypes = this.vacationTypes;
    } else {
      this.filteredVacationTypes = this.vacationTypes.filter(
        (type) => type.key == '1' || type.key == '4'
      );
    }
  }

  calculateTotalDays(): void {
    if (this.startDate && this.endDate) {
      const start = this.startDate;
      const end = this.endDate;

      const diffInDays =
        (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24) + 1;

      this.totalDays = diffInDays > 0 ? Math.round(diffInDays) : 0;
    } else {
      this.totalDays = 0;
    }
  }

  onRegister() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const randomNumber = Math.floor(100000 + Math.random() * 900000);
    const solicitudeCode = `VACATION-${randomNumber}`;
    const stateId = '1';

    const request = {
      userId: this.userData.employeeId,
      companyId: this.selectedEmpresa?.key,
      employeeId: this.selectedColaborador?.key,
      typeVacationId: this.selectedVacationType?.key,
      solicitudeCode: solicitudeCode,
      breakStartDate: this.startDate?.toISOString().replace('Z', ''),
      breakEndDate: this.endDate?.toISOString().replace('Z', ''),
      detailMessageAdmin: this.messageToCollaborator
        ? this.messageToCollaborator
        : 'Se ha realizado una solicitud de vacaciones, por favor, revisarlo y confirmar.',
      detailMessageCollaborator: this.messageCollaborator,
      detailSolicitudeId: '1',
      solicitudeId: '1',
      stateSolicitudeId: stateId,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined) {
        formData.append(key, value);
      }
    };

    Object.entries(request).forEach(([key, value]) =>
      appendIfDefined(key, value)
    );

    // Agregar archivo solo si es tipo 4 (Adelanto de Vacaciones)
    if (this.selectedVacationType?.key == '4' && this.downloadUrl) {
      formData.append('solicitudeUrl', this.downloadUrl);
      this.selectedFileName = extractFileName(this.downloadUrl);
    }

    // console.log('solicitudeUrl', this.downloadUrl);

    // Llamar al servicio para registrar el recibo de pago
    this.vacationService.createVacation(formData).subscribe({
      next: (response) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalSuccessComponent, {
          header: '',
          data: {
            text: 'Tu solicitud ha sido realizado con éxito.',
            title: '¡Éxito!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.registerComplete.emit();
        this.closeDialog();
      },
      error: (err) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          closable: true,
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        console.error('Error al registrar el recibo de pago:', err);
      },
    });
    this.closeDialog();
  }

  onCancel() {
    this.resetForm();
    this.closeDialog();
  }

  // Limpiar los campos del modal
  resetForm() {
    this.selectedEmpresa = null;
    this.selectedColaborador = null;
    this.selectedVacationType = null;
    this.startDate = null;
    this.endDate = null;
    this.messageCollaborator = '';
    this.messageToCollaborator = '';
    this.selectedDates = [];
    this.totalDays = 0;
    this.accumulatedBonusDays = 0;
    this.accumulatedDays = 0;
    this.usedDaysLaw = 0;
    this.usedBonusDays = 0;

    this.hasInteracted = {
      empresa: false,
      colaborador: false,
      tipoVacacion: false,
      endDate: false,
      startDate: false,
    };

    // this.calculateTotalDays();
    // this.syncSelectedDates();
    this.validateForm();
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'empresa':
        this.selectedEmpresa = null;
        break;
      case 'colaborador':
        this.selectedColaborador = null;
        break;
      case 'tipoVacacion':
        this.selectedVacationType = null;
        break;
      case 'status':
        this.selectedstatusSolicitude = null;
        break;
      case 'startDate':
        this.startDate = event;
        break;
      case 'endDate':
        this.endDate = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.validateForm();
  }

  validateField(field: string) {
    this.hasInteracted[field] = true;
  }

  filterVacationTypes(event: any): void {
    const query = event.query.toLowerCase();
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    this.filteredVacationTypes = this.vacationTypes.filter(
      (option) =>
        option.text.toLowerCase().includes(query) &&
        (this.startDateEmployee &&
        this.startDateEmployee.getTime() <= oneYearAgo.getTime()
          ? true
          : option.key == '1' || option.key == '4')
    );
  }

  openTooltipModal(title: string, description: string) {
    this.dialogService.open(ModalInfoComponent, {
      closable: false,
      data: {
        title: title,
        description: description,
      },
    });
  }

  onStartDateChange(selectedStartDate: Date): void {
    if (selectedStartDate) {
      this.startDate = selectedStartDate;
      this.resetDocumentState();

      if (this.selectedVacationType?.key != '4') {
        this.maxEndDate = new Date(selectedStartDate);
        this.maxEndDate.setDate(this.maxEndDate.getDate() + 14);
      } else {
        this.maxEndDate = null;
      }

      if (this.endDate && this.endDate < this.startDate) {
        this.endDate = null;
      }

      this.syncSelectedDates();
      this.calculateTotalDays();
    } else {
      this.maxEndDate = null;
      this.resetDocumentState();
    }
  }

  onEndDateChange(selectedEndDate: Date): void {
    if (selectedEndDate) {
      this.resetDocumentState();

      if (this.startDate && selectedEndDate < this.startDate) {
        this.endDate = null;
      } else {
        this.endDate = selectedEndDate;
      }

      this.syncSelectedDates();
      this.calculateTotalDays();
    }
    this.validateForm();
    this.resetDocumentState();
  }

  onRangeSelect(): void {
    if (Array.isArray(this.selectedDates) && this.selectedDates.length === 2) {
      this.resetDocumentState();

      this.startDate = this.selectedDates[0];
      this.endDate = this.selectedDates[1];
      if (this.startDate) {
        if (String(this.selectedVacationType?.key) != '4') {
          this.maxEndDate = new Date(this.startDate);
          this.maxEndDate.setDate(this.maxEndDate.getDate() + 14);
        } else {
          this.maxEndDate = null;
        }
      } else {
        this.maxEndDate = null;
      }
    }
    this.calculateTotalDays();
    this.validateForm();
  }

  syncSelectedDates(): void {
    if (this.startDate && this.endDate) {
      this.selectedDates = [this.startDate, this.endDate];
    } else {
      this.selectedDates = [];
    }
  }

  // Generar PDF
  onDownload() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const formattedDates = this.getFormattedDates();

    const request = {
      companyId: this.selectedEmpresa?.key,
      employeeId: this.selectedColaborador?.key,
      days: this.totalDays,
      daysName: numberToText(this.totalDays),
      dayStartDate: formattedDates?.startDate.day,
      monthNameStartDate: formattedDates?.startDate.month,
      yearStartDate: formattedDates?.startDate.year,
      dayEndDate: formattedDates?.endDate.day,
      monthNameEndDate: formattedDates?.endDate.month,
      yearEndDate: formattedDates?.endDate.year,
    };

    this.vacationService.postGeneratePDF(request).subscribe({
      next: (response) => {
        loadingRef.close();
        this.downloadUrl = response.solicitudePdfUrl;
        this.selectedFileName = extractFileName(response.solicitudePdfUrl);
        this.documentGenerated = true;
        const ref = this.dialogService.open(ModalSuccessComponent, {
          header: '',
          data: {
            text: 'El documento se ha generado con éxito.',
            title: '¡Éxito!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Revisar documento',
            buttonAction: () => this.downloadFile(),
          },
        });
        this.validateForm();
      },
      error: (err) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          closable: true,
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.validateForm();
        console.error('Error al generar pdf:', err);
      },
    });
    // this.closeDialog();
  }

  // Descargar PDF
  downloadFile() {
    if (!this.downloadUrl) return;

    const link = document.createElement('a');
    link.href = this.downloadUrl;
    link.target = '_blank';
    link.download = this.downloadUrl.split('/').pop() || 'documento.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  resetDocumentState() {
    this.documentGenerated = false;
    this.downloadUrl = null;
    this.currentFile = null;
    this.selectedFileName = null;
  }

  // Formateando fechas
  getFormattedDates() {
    if (!this.startDate || !this.endDate) return null;

    const startDay = this.startDate.getDate();
    const startMonth = this.startDate.getMonth() + 1;
    const startYear = this.startDate.getFullYear();

    const endDay = this.endDate.getDate();
    const endMonth = this.endDate.getMonth() + 1;
    const endYear = this.endDate.getFullYear();

    return {
      startDate: {
        day: startDay,
        month: getMonthName(startMonth),
        year: startYear,
      },
      endDate: {
        day: endDay,
        month: getMonthName(endMonth),
        year: endYear,
      },
    };
  }

  shouldDisableDownloadButton(): boolean {
    if (this.selectedVacationType?.key === '4') {
      return false;
    }

    return !this.startDate || !this.endDate;
  }
}
